import { useContext, useEffect, useMemo, useState } from 'react'
import { DesignContext } from 'contexts/DesignContext'
import { Form, Col, Row } from 'react-bootstrap'
import objectPath from 'object-path'
import Label from './Label'
import { checkIsEqual, getCheckValue } from 'designer/component/action/Data'

const CustomCheckboxInput = (props) => {
  let {
    uischema,
    updateCheckbox,
    updateInput,
    copyInput = () => {},
    copyCheckbox = () => {},
    errors = {},
    value,
    uiKey,
    uiName,
    uiInputKey,
    uiInputName,
    label,
    fieldName,
    fieldKey,
    fieldInputKey,
    fieldInputName,
    setIsOnChange,
    data,
  } = props
  let {
    checkboxWidth,
    input = { name: '', key: '', placeholder: '' },
    require,
  } = uischema
  const designContext = useContext(DesignContext)
  const { jsonForm, elementAction } = designContext
  let checked = objectPath.get(data, uiKey) || objectPath.get(data, uiName)
  let inputValue =
    objectPath.get(data, uiInputKey) || objectPath.get(data, uiInputName)
  let valueChecked = getCheckValue(uischema.valueChecked)

  let errorChecked = objectPath.get(errors, uiKey) || []
  let errorInput = objectPath.get(errors, uiInputKey) || []
  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  let hasEnable = objectPath.has(elementAction, ['isEnable', uiKey])
  let isEnable = objectPath.get(elementAction, ['isEnable', uiKey])
  let isReadOnly = useMemo(() => {
    if (isLocked) return isLocked
    if (hasEnable) {
      return isEnable === false ? true : false
    }
    return uischema.readonly
  }, [isEnable, uischema.readonly])

  let hasRequire = objectPath.has(elementAction, ['isRequire', uiKey])
  let requireMessage = objectPath.get(elementAction, ['isRequire', uiKey])
  let showRequireMessage = hasRequire
    ? typeof requireMessage !== 'boolean'
    : require
  let isRequire = hasRequire || require
  let showRequire = value ? false : isRequire ? true : false

  let hasWarning = objectPath.has(elementAction, ['isWarning', uiKey])
  let warningMessage = objectPath.get(elementAction, ['isWarning', uiKey])
  let showWarningMessage = hasWarning
    ? typeof warningMessage !== 'boolean'
    : warningMessage

  let hasRequireInput = objectPath.has(elementAction, ['isRequire', uiKey])
  let requireMessageInput = objectPath.get(elementAction, ['isRequire', uiKey])
  let showRequireMessageInput = hasRequire
    ? typeof requireMessageInput !== 'boolean'
    : input?.require
  let isRequireInput = hasRequireInput || input?.require
  let showRequireInput = inputValue ? false : isRequireInput ? true : false

  let hasWarningInput = objectPath.has(elementAction, ['isWarning', uiKey])
  let warningMessageInput = objectPath.get(elementAction, ['isWarning', uiKey])
  let showWarningMessageInput = hasWarningInput
    ? typeof warningMessage !== 'boolean'
    : warningMessageInput

  let isCheck = checkIsEqual(checked, valueChecked)

  const styleChange = useMemo(() => {
    let style = {
      width: checkboxWidth ? checkboxWidth : '18px',
      height: checkboxWidth ? checkboxWidth : '18px',
    }
    return style
  }, [checkboxWidth])

  const [render, setRender] = useState(false)

  useEffect(() => {
    if (render) {
      setRender(false)
    }
  }, [render])

  return (
    <Form.Group className="mb-0" controlId={uischema.controlId}>
      <Row className="w-100 mx-0">
        {label && (
          <Label
            {...props}
            id={`label-${fieldKey}`}
            name={`label-${fieldName}`}
            uischema={uischema}
            label={label}
            mt={0}
            isRequire={isRequire}
            isEnable={!label}
            onClick={() => {
              updateCheckbox(!isCheck, true)
              copyCheckbox(!isCheck)
              setIsOnChange(true)
              setRender(true)
            }}
          />
        )}
        <Col sm="auto" className="d-flex align-items-center px-0">
          <Form.Control
            id={`checkbox-${fieldKey}`}
            name={`checkbox-${fieldName}`}
            style={styleChange}
            type="checkbox"
            checked={isCheck}
            onChange={(e) => {
              let checked = e.target.checked
              updateCheckbox(checked, true)
              copyCheckbox(checked)
              setIsOnChange(true)
              setRender(true)
            }}
            disabled={isReadOnly}
          />
        </Col>
        {uischema?.checkboxText && (
          <Label
            {...props}
            id={`checkbox-text-${fieldKey}`}
            name={`checkbox-text-${fieldName}`}
            uischema={uischema}
            label={uischema.checkboxText}
            isRequire={isRequire}
            isEnable={uischema?.checkboxText && !uischema.label}
            onClick={() => {
              updateCheckbox(!isCheck, true)
              copyCheckbox(!isCheck)
              setIsOnChange(true)
              setRender(true)
            }}
          />
        )}
        <Col className="pl-0">
          <Form.Control
            id={`input-${fieldInputKey}`}
            name={`input-${fieldInputName}`}
            type="text"
            placeholder={input && input.placeholder}
            autoComplete="off"
            value={inputValue || ''}
            minLength={uischema.minLength}
            maxLength={uischema.maxLength}
            onChange={(e) => {
              updateInput(e.target.value, true)
              copyInput(e.target.value)
              setRender(true)
            }}
            readOnly={isReadOnly || !isCheck}
          />
        </Col>
      </Row>
      <ul className="m-0 mt-2">
        {showRequire && showRequireMessage && requireMessage && (
          <li className="text-danger">{requireMessage}</li>
        )}
        {showWarningMessage && warningMessage && (
          <li className="text-warning">{warningMessage}</li>
        )}
        {showRequireInput && showRequireMessageInput && (
          <li className="text-danger">{requireMessageInput}</li>
        )}
        {showWarningMessageInput && warningMessageInput && (
          <li className="text-warning">{warningMessageInput}</li>
        )}
        {errorInput.map((error, index) => (
          <li key={`error-${input.key}-${index + 1}`} className="text-danger">
            {error}
          </li>
        ))}
        {errorChecked.map((error, index) => (
          <li
            key={`error-${uischema.key}-${index + 1}`}
            className="text-danger"
          >
            {error}
          </li>
        ))}
      </ul>
    </Form.Group>
  )
}

export default CustomCheckboxInput
